module.exports = __webpack_public_path__ + "static/model_OJP2_ujecie192-2-98b29fe99a0d9987fb730c888eb613ce.jpg";